export enum CookbookCategoryTypeEnum {
  SLIDER = 'SLIDER',
  LIST = 'LIST',
  DIET_TYPES_SLIDER = 'DIET_TYPES_SLIDER',
}

type PageInfo = {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string;
  endCursor: string;
};

export interface CookbookTag {
  id: number;
  name: string;
  imageUrl: string;
  mealsCount: number;
  __typename?: string;
}

export interface CookbookCategoryTag {
  id: number;
  name: string;
  imageUrl: string;
  mealsCount: number;
  __typename?: string;
}

export interface CategoryMealTag {
  id: number;
  name: string;
  labelColor?: string;
  __typename?: string;
}

type CookbookTags = {
  dietTypeTags: CookbookTag[];
  mealTypeTags: CookbookTag[];
};

type CategoryMealTags = {
  dietTypeTags: CategoryMealTag[];
  mealTypeTags: CategoryMealTag[];
  customTags: CategoryMealTag[];
};
type SearchMealTags = {
  dietTypeTags: CategoryMealTag[];
  mealTypeTags: CategoryMealTag[];
  cusromTags: CategoryMealTag[];
};

type CookbookMacronutrientDetails = {
  grams: number;
  kcal: number;
  percentage: number;
};

type CookbookMealNutritionServing = {
  kcal: number;
  protein: CookbookMacronutrientDetails;
  fat: CookbookMacronutrientDetails;
  carbohydrates: CookbookMacronutrientDetails;
};

type CookbookMealNutrition = {
  singleServing: CookbookMealNutritionServing;
  allServings: CookbookMealNutritionServing;
};

type CookbookIngredientCategory = {
  id: number;
  name: string;
  isSeasoning: boolean;
  isOptional: boolean;
};

type CookbookIngredientMeasurement = {
  amount: number;
  unit: number;
  text: string;
};

type CookbookIngredient = {
  id: number;
  name: string;
  category: CookbookIngredientCategory;
  measurements: CookbookIngredientMeasurement[];
};

type CookbookDish = {
  id: number;
  name: string;
  recipe: string;
  ingredients: [CookbookIngredient];
};

export type CookbookMeal = {
  id: number;
  isFavorite: boolean;
  name: string;
  preparationVideoUrl: string;
  preparationImageUrl: string;
  tags: CookbookTags;
  preparationTime: string;
  portions: number;
  nutrition: CookbookMealNutrition;
  dishes: CookbookDish[];
};

export type CookbookCategoryMeal = {
  id: number;
  isFavorite: boolean;
  name: string;
  preparationImageUrl: string;
  preparationTime: {
    minutes: number;
  };
  nutrition: CookbookMealNutrition;
  tags: CategoryMealTags;
};

export type CookbookSearchMeal = {
  id: number;
  isFavorite: boolean;
  name: string;
  preparationImageUrl: string;
  preparationTime: {
    minutes: number;
  };
  nutrition: CookbookMealNutrition;
  tags: SearchMealTags;
};

export type CookbookMealEdge = {
  node: CookbookMeal;
  cursor: string;
};

export type CookbookMealSearchEdge = {
  node: CookbookSearchMeal;
};

export type CookbookMealListEdge = {
  node: CookbookCategoryMeal;
};

type CookbookCategoryMealEdge = {
  node: CookbookCategoryMeal;
  cursor: string;
};

export type CookbookMealsConnection = {
  edges: CookbookMealEdge[];
  pageInfo?: PageInfo;
};

export type CookbookMealSearchConnection = {
  edges: CookbookMealSearchEdge[];
};

export type CookbookMealListConnection = {
  edges: CookbookMealListEdge[];
};

type CookbookCategoryMealsConnection = {
  edges: CookbookCategoryMealEdge[];
  pageInfo?: PageInfo;
};

export type MealsSearchCriteriaInputType = {
  query?: string;
  categories?: number[];
  mealTypeTags?: number[];
  dietTypeTags?: number[];
  favoriteMeals?: boolean;
};

export interface CookbookCategory {
  id: number;
  type: CookbookCategoryTypeEnum;
  name: string;
  position: number;
}

export enum CookbookCategoryTypename {
  SLIDER = 'SliderCookbookCategory',
  LIST = 'ListCookbookCategory',
  DIET_TYPES_SLIDER = 'DietTypesSliderCookbookCategory',
}

export interface SliderCookbookCategory extends CookbookCategory {
  meals: CookbookCategoryMealsConnection;
  tagsVisibility: {
    dietTypeTagsVisibleOnHomepage: boolean;
    mealTypeTagsVisibleOnHomepage: boolean;
    customTagsVisibleOnHomepage: boolean;
  };
  __typename: CookbookCategoryTypename.SLIDER;
}

export interface ListCookbookCategory extends CookbookCategory {
  meals: CookbookCategoryMealsConnection;
  tagsVisibility: {
    dietTypeTagsVisibleOnHomepage: boolean;
    mealTypeTagsVisibleOnHomepage: boolean;
    customTagsVisibleOnHomepage: boolean;
  };
  __typename: CookbookCategoryTypename.LIST;
}

export interface DietTypesSliderCookbookCategory extends CookbookCategory {
  tags: CookbookCategoryTag[];
  __typename: CookbookCategoryTypename.DIET_TYPES_SLIDER;
}

export interface SearchMealsQueryResult {
  cookbook: {
    meals: CookbookMealSearchConnection;
  };
}

export interface SearchMealListQueryResult {
  cookbook: {
    meals: CookbookMealListConnection;
  };
}

export interface MealQueryResult {
  cookbook: {
    meal: CookbookMeal;
  };
}
export interface SearchVariables {
  searchCriteria?: MealsSearchCriteriaInputType;
}

export interface CookbookTagsResult {
  cookbook: {
    tags: {
      mealTypeTags: CookbookTag[];
    };
  };
}
